import React from 'react'

import { withMicrocopy } from '~contexts/MicrocopyContext'
import CodeBlock from '~components/CodeBlock'

const ResponseExample = ({ 
  code,
  microcopy 
}) => (
  <>
    { code && (
      <section>
        <header id='response-example'>
          <h2>
            <a href='#response-example' data-display-anchor>
              { microcopy.text('reference.titles.response_example') }
            </a>
          </h2>
        </header>
        <CodeBlock language='json' code={code} />
      </section>
    )}
  </>
)

export default withMicrocopy(ResponseExample)